import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
//import DemoTable from './DemoTable'
import ImgMediaCard from '../common/FeatureCard'
const BackgroundImg = require ('./../../images/graphics/nurse_doctor_ipad.png')
const ProductDesktop = require ('./../../images/graphics/ipad_pro_mockup.png')
const ProductTablet = require ('./../../images/graphics/ipad_pro_mockup_2.png')
const ProductMobile = require ('./../../images/graphics/iphone_max.png')


// ADMIN MENU DATA ------------------------------------

const admin_menu_data = [
    {
        title: 'Residents',
        link:'',
        desc:'',
        data:[

        ]
    },
    {
        title: 'Users',
        link:'',
        desc:'',
    },
    {
        title: 'Clinicians',
        link:'',
        desc:'',
    },
    {
        title: 'Pharmacies',
        link:'',
        desc:'',
    },
    {
        title: 'Prescriptions',
        link:'',
        desc:'',
    },
    {
        title: 'Labs',
        link:'',
        desc:'',
    },
    {
        title: 'Activity',
        link:'',
        desc:'',
    },
    {
        title: 'Vitals',
        link:'',
        desc:'',
    },
]
// CARD DATA ------------------------------------

const cards_data = [
  {
    title: 'Residents',
    image_path: 'smart_health.png',
    text: 'Manage residents in assisted living w advanced care inforamtion. Residents total information view w realtime tracking.',
    link: '/residents',
  },
  {
    title: 'Facilities',
    image_path: 'living_facility.jpg',
    text: 'Supervise building utilities and other information for care facility to ensure all topics are to specification and running.',
    link: '/facility',
  },
  {
    title: 'Admin',
    image_path: 'health_data_network.jpg',
    text: 'Customize the platform to suite your specific needs, by modifying and extedning the platform with information from your organization.',
    link: '/admin',
  },
]
// TAB PANEL ------------------------------------

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


// CSS STYLES ------------------------------------

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    textAlign: 'left',
    '& header': {
      background: '#ffffff',
      background: '-moz-linear-gradient(top,  #ffffff 0%, #e6eff4 100%)',
      background: '-webkit-linear-gradient(top,  #ffffff 0%,#e6eff4 100%)',
      background: 'linear-gradient(to bottom,  #ffffff 0%,#e6eff4 100%)',
      filter: 'progid:DXImageTransform.Microsoft.gradient( startColorstr="#ffffff", endColorstr="#e6eff4",GradientType=0 )',
      color: '#8795a5',
    },
  },
  bar: {
    background: '#5592de',
  },
  tabpanel:{
      '& h2':{
        color: '#436f96',
        textAlign:'left',
      }
  },
  app_features:{
    maxWidth: 1300,
    border: 'none',
    padding: 10,
    margin: '10px auto',
    backgroundColor: '#fff',
  },
  intro:{
    padding: '20px 40px',
    color: '#fff',
    //color: '#000',
    textShadow: '1px 3px 4px #025',
    //textShadow: '2px 2px 5px #def',
    background: 'rgba(34, 78, 111, 0.6)',
    //background: 'rgba(255,255,255,.5)',
    '& p': {
      padding: '10px 0',
      borderTop: '1px solid #ccc',
      borderBottom: '1px solid #ccc',
    }
  },
  homesplash:{
      backgroundSize: 'cover',
      backgroundPosition: 'center 79%',
      backgroundImage: `url(${BackgroundImg})`,
      width: '100%',
      height: 300,
  },
  product_image:{
      width: 'auto',
      height: 200,
      display:'block',
      margin: 'auto',
  },
  footerpad:{
      height: 150,
  }
}));


// MAIN COMPONENENT ------------------------------------
export default function AboutPage() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const cardset = cards_data.map((item, index) =>
    //<Link to={'/admin/'+item.link}> <Tab key={index} value={index} label={item.title} {...a11yProps(index) }>{item.title}</Tab> </Link>
    <Grid item xs={12} md={4}>
      <ImgMediaCard {...item} />
    </Grid>
    )

  return (
    <div className={classes.root}>
        <div className={classes.homesplash}>
            {/*
        <Grid container spacing={2}>
            <Grid item xs={12} md={5}>
                <div className={classes.intro}>
                    <h3>Spectator Health - <br/>Healthcare Innovation Technologies</h3>
                    <p>Spectator Health develops leading edge technology for improving quality of care with patient and resident centric tecnology platform intergating various participants and systems across the healthcare experience.</p>
                </div>
            </Grid>
        </Grid>
        */}
      </div>

        <Paper variant="outlined" className={classes.app_features} >
        <Grid container spacing={4}>
                
        <Grid item xs={12} md={6}>
            <h4>Desktop Web Application</h4>
            <p>Spectator Health platform is a full-featured application providing access to resident data for various roles and administration.  We work closely with healthcare practitioners, assisted care workers, and health facility residents to understand the experience, which informs our technology solutions to directly improve workflows and meet needs on a daily basis.</p>
        </Grid>
        <Grid item xs={12} md={6}>
            <img src={ProductDesktop} className={classes.product_image}/>
        </Grid>

        <Grid item xs={12} md={6}>
            <h4>Tablet App for Practitioners</h4>
            <p>Healthcare workers often see many patients and residents daily while working together as teams to both monitor and respond to individual needs.  Our portable tablet-based app brings much of the information about patient and resident populations to care workers fingertips, allowing them to have the information they need and provide better personalized care.</p>
        </Grid>
        <Grid item xs={12} md={6}>
            <img src={ProductTablet} className={classes.product_image}/>
        </Grid>


        <Grid item xs={12} md={6}>
            <h4>Mobile Monitoring</h4>
            <p>Our mobile application allows care teams to be on-the-go while loved ones can monitor alert activity or access key information, so those we care for have 24/7 support from flexible teams.  We know how important it is to have peace-of-mind that your loved ones are receiving the best care possible and are supported by a responsive community.</p>
        </Grid>
        <Grid item xs={12} md={6}>
            <img src={ProductMobile} className={classes.product_image}/>
        </Grid>

        <Grid item xs={12} className={classes.footerpad}>
             
        </Grid>

        </Grid>
        </Paper>
    </div>
  );
}